/**
 * @generated SignedSource<<574791b41b5b60c42abb5a1782ad62e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightEditGeneralInfoDetails_flight$data = {
  readonly bookingToken: string | null;
  readonly priceKey: string;
  readonly updateUrl: string | null;
  readonly " $fragmentType": "FlightEditGeneralInfoDetails_flight";
};
export type FlightEditGeneralInfoDetails_flight$key = {
  readonly " $data"?: FlightEditGeneralInfoDetails_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightEditGeneralInfoDetails_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightEditGeneralInfoDetails_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updateUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookingToken",
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "cbede9ed9ca5025c139003ab16f3ce25";

export default node;
